export const products = [
    {
        id: 1,
        name:'Crocine',
        price: 30,
        quantity: 1,
        img: require('../images/crocine.webp'),
        description: 'Headache'
    },
    {
        id: 2,
        name:'Aciloc',
        price: 40,
        quantity: 1,
        img: require('../images/aciloc.webp'),
        description: 'Acidity'
    },
    {
        id: 3,
        name:'Calpol',
        price: 13,
        quantity: 1,
        img: require('../images/calpol.jpg'),
        description: 'Headache Body Pain'
    },
    {
        id: 4,
        name:'Vicks Action 500',
        price: 59,
        quantity: 1,
        img: require('../images/vicks.jpg'),
        description: 'Cold & Cough'
    },
    {
        id: 5,
        name:'Disprin',
        price: 14,
        quantity: 1,
        img: require('../images/disprin.jpg'),
        description: 'Headache'
    },
    {
        id: 6,
        name:'Metrogyl',
        price: 21,
        quantity: 1,
        img: require('../images/metrogyl.jpg'),
        description: 'Loose Motion'
    },
    {
        id: 7,
        name:'Omee',
        price: 55,
        quantity: 1,
        img: require('../images/omee.webp'),
        description: 'Acidity'
    },
    {
        id: 8,
        name:'Liv 52',
        price: 120,
        quantity: 1,
        img: require('../images/liv52.webp'),
        description: 'Liver'
    },
    {
        id: 9,
        name:'Pentop DSR',
        price: 119,
        quantity: 1,
        img: require('../images/pentop.jpg'),
        description: 'Gas & Acidity'
    },
    {
        id: 10,
        name:'Corex Cough Syrup',
        price: 121,
        quantity: 1,
        img: require('../images/corex.jpg'),
        description: 'Cough'
    },
    {
        id: 11,
        name:'Cetirizine',
        price: 18,
        quantity: 1,
        img: require('../images/cetirizine.webp'),
        description: 'Alergy'
    },
    {
        id: 12,
        name:'Paracetamol',
        price: 6,
        quantity: 1,
        img: require('../images/paracetamol.webp'),
        description: 'Body Pain & Fever'
    },
    {
        id: 13,
        name:'Tylenol',
        price: 200,
        quantity: 1,
        img: require('../images/tylenol.jpg'),
        description: 'Flu & Cold'
    },
    {
        id: 14,
        name:'Panadol',
        price: 58,
        quantity: 1,
        img: require('../images/Panadol.png'),
        description: 'Flu & Cold'
    },
    {
        id: 15,
        name:'Codral',
        price: 32,
        quantity: 1,
        img: require('../images/codral.jpg'),
        description: 'Flu & Cold'
    },
    {
        id: 16,
        name:'Zeerodol',
        price: 49,
        quantity: 1,
        img: require('../images/zeerodol.jpg'),
        description: 'Pain'
    },
    {
        id: 17,
        name:'Aldigesic',
        price: 63,
        quantity: 1,
        img: require('../images/aldigesic.jpg'),
        description: 'Pain'
    },
    {
        id: 18,
        name:'Combiflam',
        price: 39,
        quantity: 1,
        img: require('../images/combiflam.webp'),
        description: 'Pain'
    },
    {
        id: 19,
        name:'Acnezox Gel',
        price: 15,
        quantity: 1,
        img: require('../images/acnezox.jpg'),
        description: 'Pimples'
    },
    {
        id: 20,
        name:'Persol Gel',
        price: 106,
        quantity: 1,
        img: require('../images/persol.jpg'),
        description: 'Pimples'
    },
    {
        id: 21,
        name:'NeoClean',
        price: 135,
        quantity: 1,
        img: require('../images/neoclean.webp'),
        description: 'Pimples'
    },
    {
        id: 22,
        name:'Sidpiles',
        price: 165,
        quantity: 1,
        img: require('../images/sidpiles.jpg'),
        description: 'Piles'
    },
    {
        id: 23,
        name:'Pilex',
        price: 160,
        quantity: 1,
        img: require('../images/pilex.jpg'),
        description: 'Piles'
    },
    {
        id: 24,
        name:'Arsh Kalp',
        price: 108,
        quantity: 1,
        img: require('../images/arshkalp.jpg'),
        description: 'Piles'
    },
    {
        id: 25,
        name:'Solvin Cough Syrup',
        price: 73,
        quantity: 1,
        img: require('../images/solvin.jpg'),
        description: 'Cough'
    },
    {
        id: 26,
        name:'Benadryl Cough Syrup',
        price: 120,
        quantity: 1,
        img: require('../images/benadryl.webp'),
        description: 'Cough'
    },
    {
        id: 27,
        name:'Ashthakind Syrup',
        price: 70.40,
        quantity: 1,
        img: require('../images/asthakind.jpg'),
        description: 'Cough'
    },
    {
        id: 28,
        name:'Torex Syrup',
        price: 78,
        quantity: 1,
        img: require('../images/torex.png'),
        description: 'Cough'
    }

]

export const images = [
   {
    id: 1,
    img: require('../images/1.jpg')
   },
   {
    id: 2,
    img: require('../images/2.jpg')
   },
   {
    id: 3,
    img: require('../images/3.jpg')
   },
   {
    id: 4,
    img: require('../images/3.jpg')
   }

    // Add more image URLs as needed
];
 export const team = [
    {
        id: 1,
        name:'Ankit Pandey',
        role: 'Frontend & Backend',
        facebook: 'https://facebook.com/pandeyankit2001',
        whatsapp: 'https://wa.me/+916391735294',
        instagram: 'https://www.instagram.com/ankitpandey_401',
        img: require('../images/ankit.jpeg')
    },
    {
        id: 2,
        name:'Adarsh Mishra',
        role: 'Project Leader',
        facebook: 'https://facebook.com',
        whatsapp: 'https://wa.me/+918920661951',
        instagram: 'https://www.instagram.com/im._.adarshmishra',
        img: require('../images/adarssh.jpg')
    },
    {
        id: 3,
        name:'Shailendra Singh',
        role: 'Medicine Expert',
        facebook: 'https://facebook.com',
        whatsapp: 'https://wa.me/+919838981288',
        instagram: 'https://www.instagram.com/whimsicalrajput818',
        img: require('../images/shailendra.jpeg')
    },
    {
        id: 4,
        name:'Anchit Gupta',
        role: 'Designer',
        facebook: 'https://facebook.com',
        whatsapp: 'https://wa.me/+917307207896',
        instagram: 'https://www.instagram.com/_x_anshu_01',
        img: require('../images/anchit.jpeg')
    },
    {
        id: 5,
        name:'Maneesh Kumar',
        role: 'Spelling Check',
        facebook: 'https://facebook.com',
        whatsapp: 'https://wa.me/+917521069257',
        instagram: 'https://www.instagram.com',
        img: require('../images/manish.jpeg')
    }
 ]


 export const category = [
    {
        id: 1,
        name: 'Personal Care',
        img: require('../images/PersonalCare.jpg'),
        itemCount: '14'
    }, 
    {
        id: 2,
        name: 'Covid Essentials',
        img: require('../images/CovidEssentials.jpg'),
        itemCount: '20'
    },
    {
        id: 3,
        name: 'Prescription',
        img: require('../images/Prescription.jpg'),
        itemCount: '100'
    },
    {
        id: 4,
        name: 'Baby Care',
        img: require('../images/BabyCare.jpeg'),
        itemCount: '10'
    },
    {
        id: 5,
        name: 'Equipements',
        img: require('../images/Devices.jpg'),
        itemCount: '23'
    }
 ]